const project = {
  slug: "prediction-market-arbitrage-bot",
  title: "Prediction Market Arbitrage Bot",
  oneLiner: "Automated sub-$1.00 binary pair execution on Polymarket with real-time risk controls and live monitoring.",
  role: ["Systems Engineer", "Algorithmic Trading Developer"],
  category: "AI/ML",
  clientOrOrg: "Independent Build",
  timeframe: { start: "2025-01", status: "In Progress" },
  domain: ["FinTech", "Algorithmic Trading", "Systems Engineering"],
  tech: ["Rust", "TypeScript", "React", "Redis", "WebSockets", "Polymarket CLOB API", "Raspberry Pi"],
  links: {},
  gallery: [
    {
      src: "/assets/polymarket/polymarket-bot-1.png",
      alt: "Polymarket bot dashboard showing live positions and market tracking"
    },
    {
      src: "/assets/polymarket/polymarket-bot-2.png",
      alt: "Polymarket bot interface showing order views and trading activity"
    }
  ],
  impact: [
    "Built an automated arbitrage strategy that accumulated both sides of binary markets below $1.00 combined cost, creating guaranteed payout spread before fees.",
    "Protected deployed capital with allocation buckets, imbalance guards, and deferred refunds that prevented overspending during cancel-fill race conditions."
  ],
  responsibilities: [
    "Engineered the core execution engine in Rust with live market-data streaming, opportunity detection, and post-only limit ladder placement.",
    "Implemented Redis-backed state, automatic position reconciliation from the Polymarket Data API, and safe paper/live trading mode switching."
  ],
  features: [
    "Real-time WebSocket price streaming and cross-side arbitrage detection",
    "Post-only order management with layered limit orders, cancellations, and re-quoting",
    "Bucket-based capital allocation across mid, outer, extreme, and savings bands",
    "Live React dashboard for positions, per-side orders, P/L, and resolved market history"
  ],
  architecture: [
    "Rust trading service connected to Polymarket CLOB market data and execution endpoints",
    "Redis persistence for orders, fills, balances, and restart-safe recovery",
    "TypeScript/React dashboard backed by a WebSocket-enabled REST API",
    "Raspberry Pi deployment for always-on execution and monitoring"
  ],
  seo: {
    title: "Prediction Market Arbitrage Bot - Polymarket Trading System",
    description:
      "Built a Polymarket arbitrage bot with Rust, Redis, WebSockets, and React to capture sub-$1.00 binary pairs with real-time risk controls."
  },
  cover: "/assets/polymarket/arbbot-featured.png"
};

export default project;
